import { getGridNumericOperators } from '@mui/x-data-grid-pro'
import { FILTER_OPERATOR_LABELS, RELEVANT_NUMBER_OPERATORS } from '@shared/constants/dataGrid'

import { QuestionListColumnType } from '../questionListDataGridColumns'

export const keyColumnModel: QuestionListColumnType = {
  field: 'key',
  width: 100,
  filterOperators: getGridNumericOperators().filter((operator) =>
    Object.keys(RELEVANT_NUMBER_OPERATORS).includes(operator.value)).map((operator) => ({
    ...operator,
    InputComponentProps: {
      inputProps: {
        type: 'text'
      }
    },
    value: RELEVANT_NUMBER_OPERATORS[operator.value as keyof typeof RELEVANT_NUMBER_OPERATORS],
    label: FILTER_OPERATOR_LABELS[operator.value as keyof typeof FILTER_OPERATOR_LABELS]
  })),
  valueGetter: (params) => params.row.questionKey
}
